import { useLocation } from 'react-router';

import { css } from '@sorare/css';

import { JonumVerificationStatus } from '#src/__generated__/globalTypes.ts';
import { Dialog } from '#src/components/dialog/index.tsx';
import { ANY_SPORT_ONBOARDING_JONUM_VERIFIED } from '#src/constants/__generated__/routes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { OneTimeDialog } from '#src/contexts/oneTimeDialog/Provider.tsx';
import { useApplyJonumRestriction } from '#src/hooks/useApplyJonumRestriction.ts';
import { LIFECYCLE } from '#src/hooks/useLifecycle.ts';
import { laptopAndAbove } from '#src/style/mediaQuery.ts';

import { JonumVerifiedView } from './JonumVerifiedView.tsx';

const dialog = css`
  @media ${laptopAndAbove} {
    max-height: 80vh;
  }
`;

export const JonumVerifiedDialog = () => {
  const isJonumActive = useApplyJonumRestriction();
  const { currentUser } = useCurrentUserContext();
  const { pathname } = useLocation();

  const status = currentUser?.jonumVerification?.status;
  const onWebviewPage = pathname.endsWith(ANY_SPORT_ONBOARDING_JONUM_VERIFIED);
  const shouldShow =
    !!currentUser &&
    isJonumActive &&
    status === JonumVerificationStatus.VERIFIED &&
    !onWebviewPage;

  if (!shouldShow) return null;

  return (
    <OneTimeDialog dialogId={LIFECYCLE.sawJonumVerifiedDialog}>
      {({ open, onClose }) => (
        <Dialog
          className={dialog}
          open={open}
          onClose={onClose}
          hideHeader
          maxWidth="xs"
          fullWidth
          disableBackdropClick
          disableEscapeKeyDown
        >
          <JonumVerifiedView onConfirm={onClose} />
        </Dialog>
      )}
    </OneTimeDialog>
  );
};
